module.exports = __webpack_public_path__ + "static/media/social_skillsf751f904.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/social_skills.svg
// module id = 1342
// module chunks = 0